import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchTaxNumberInvalidModal = createAsyncThunk(
  "taxNumberInvalidModal/fetchTaxNumberInvalidModal",
  async (language) => {
    return fetch(`${baseUrl}/api/invalid-tax-no/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language": language === "en" ? "en-UK" : language,
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getTaxNumberInvalid = (language) => async (dispatch) => {
  const result = await dispatch(fetchTaxNumberInvalidModal(language));
  const { data, responseStatus } = result.payload;
  dispatch(setShowServerErrorMessage(responseStatus));
  return data;
};

export const taxNumberInvalidModalSlice = createSlice({
  name: "companyDuplicateModal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaxNumberInvalidModal.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTaxNumberInvalidModal.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchTaxNumberInvalidModal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default taxNumberInvalidModalSlice.reducer;
